import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {FullGameResponseRepository} from "./full-game-response.repository";
import {FullGameResponseFactory} from "./full-game-response-factory";

export class FullGameResponseDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, FullGameResponseRepository, FullGameResponseFactory, DomainRequestManager];
}
